var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPadlock = function SvgPadlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "inherit",
    viewBox: "0 0 17 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.776 2.857A2.857 2.857 0 0 0 5.92 5.714v2.143a1.429 1.429 0 0 1-2.857 0V5.714a5.714 5.714 0 1 1 11.429 0v2.143a1.429 1.429 0 1 1-2.858 0V5.714a2.857 2.857 0 0 0-2.857-2.857",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.547 7.77a2.14 2.14 0 0 0-.628 1.516v8.571A2.143 2.143 0 0 0 3.062 20H14.49a2.143 2.143 0 0 0 2.143-2.143V9.286a2.143 2.143 0 0 0-2.143-2.143H3.062c-.569 0-1.114.226-1.515.628m5.967 7.064a1.786 1.786 0 1 1 2.525-2.525 1.786 1.786 0 0 1-2.525 2.525",
    clipRule: "evenodd"
  })));
};
export default SvgPadlock;